import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { tailwindVariants } from "@air/tailwind-variants";
import { forwardRef } from "react";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
const MAX_VALUES_TO_SHOW = 3;
export const filterButton = tailwindVariants({
    base: "flex h-6 shrink-0 cursor-pointer items-center gap-1 rounded-sm border pl-2 text-12 font-medium",
    variants: {
        state: {
            default: "",
            active: ""
        },
        hasClose: {
            true: "pr-7",
            false: "pr-2"
        }
    },
    defaultVariants: {
        state: "default",
        hasClose: false
    }
});
export const FilterButton = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { count, Icon, isOpen, onRemoveClick, title, values, ...restOfProps } = param;
    const hasCloseButton = !!onRemoveClick && (!!count || !!(values === null || values === void 0 ? void 0 : values.length));
    const { searchImprovements } = useTemporaryFeatureFlags();
    const isActive = isOpen || !!(values === null || values === void 0 ? void 0 : values.length) || !!count;
    const isTruncated = !!values && values.length > MAX_VALUES_TO_SHOW || !values && !!count || !searchImprovements && (!!count || !!(values === null || values === void 0 ? void 0 : values.length));
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative shrink-0",
        "data-testid": "FILTER_BUTTON_CONTAINER",
        "data-title": title,
        "data-truncated": isTruncated,
        children: [
            /*#__PURE__*/ _jsx(Button, {
                appearance: searchImprovements ? "outline" : "filled",
                className: hasCloseButton ? "pr-5" : "pr-2",
                color: isActive ? "blue" : "grey",
                "data-testid": "FILTER_BUTTON",
                "data-title": title,
                prefix: Icon && /*#__PURE__*/ _jsx(Icon, {
                    className: "size-3 shrink-0"
                }),
                suffix: isTruncated && !searchImprovements && /*#__PURE__*/ _jsx("span", {
                    className: "flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-24 bg-blue-11 px-1 text-center text-10 font-bold text-blue-1",
                    "data-testid": "FILTER_BUTTON_COUNT",
                    children: (values === null || values === void 0 ? void 0 : values.length) || count
                }),
                size: "small",
                ref: ref,
                ...restOfProps,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-1",
                    children: [
                        isTruncated && searchImprovements && (count || (values === null || values === void 0 ? void 0 : values.length)) && /*#__PURE__*/ _jsx("span", {
                            "data-testid": "FILTER_BUTTON_COUNT",
                            children: count || (values === null || values === void 0 ? void 0 : values.length)
                        }),
                        (values === null || values === void 0 ? void 0 : values.length) && !isTruncated ? values.join(", ") : title
                    ]
                })
            }),
            hasCloseButton && /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                className: "absolute right-1 top-1/2 -translate-y-1/2",
                color: isActive ? "blue" : "grey",
                "data-testid": "FILTER_BUTTON_CLOSE",
                icon: Close,
                label: "Clear filters",
                onClick: onRemoveClick,
                size: "extra-small"
            })
        ]
    });
});
FilterButton.displayName = "FilterButton";
